// React
import React from "react";

// Material UI
import { Tab } from "@mui/material";

// Components
import { MNTabs } from "Common/Components";
import { lookupStepForError } from "../utils";

// Validation
import { pageFormValidation } from "Validation";

// Styles
import { styles as tabStyles } from "Common/Components/MNTabs/styles";

const PageTabs = ({
  formik,
  clientSteps,
  stepFieldsMap,
  currentStepFields,
  page,
  setPage,
  handleOpenSnackbar,
}) => {
  const handleTabChange = async (_, newValue) => {
    // Validate the current step fields
    if (await pageFormValidation(formik, currentStepFields)) {
      setPage(newValue);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const stepName = lookupStepForError(
        Object.keys(formik.errors)[0],
        stepFieldsMap
      );
      handleOpenSnackbar(
        `There must not be any errors in the ${stepName} step.`
      );
    }
  };

  return (
    <MNTabs value={page} onChange={handleTabChange} tabName={"Client Steps"}>
      {clientSteps.slice(0, -1).map((step, index) => (
        <Tab
          key={index}
          label={step}
          sx={tabStyles.MNTabStyle(index === page)}
        />
      ))}
    </MNTabs>
  );
};

export default PageTabs;
